import React from 'react'
import block from 'bem-cn'

const b = block('bonus-loading')

export const Loading: React.FC = () => (
  <div className={b()}>
    <div className={b('container')}>
      <span className={b('circle').mix('timer-circle-1')} />
      <span className={b('circle').mix('timer-circle-2')} />
      <span className={b('circle').mix('timer-circle-3')} />
    </div>
  </div>
)
